import { styled, Tab, Tabs } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_BUTTON_BACKGROUND,
  DARK_BUTTON_BORDER,
  DARK_CARDS_CONTAINER,
  LIGHT_BUTTON_BACKGROUND,
  LIGHT_BUTTON_BORDER,
  LIGHT_CONTAINER,
  PLAIN_ICON,
  PRIMARY_BUTTON_BORDER,
  PRIMARY_ICON,
} = COLORS;

export const MainContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 30,

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },

  [theme.breakpoints.down('xs')]: {
    gap: 10,
  },
}));

export const CustomTabs = styled(Tabs)(({ theme }) => ({
  minWidth: 240,

  '& .MuiTabs-indicator': {
    display: 'none',
  },

  [theme.breakpoints.down('md')]: {
    '& .MuiTabs-flexContainer': {
      flexDirection: 'unset',
      gap: 20,
      minWidth: 'unset',
    },
  },
  [theme.breakpoints.down('xs')]: {
    '& .MuiTabs-flexContainer': {
      gap: 20,
    },
  },
}));

export const TabItem = styled(Tab)(({ theme }) => ({
  //MAIN MENU COLOR
  background: theme.palette.type === 'dark' ? DARK_BUTTON_BACKGROUND : LIGHT_BUTTON_BACKGROUND,
  width: '100%',
  marginBottom: 10,
  borderRadius: 8,
  border: '1px solid',
  borderColor: theme.palette.type === 'dark' ? DARK_BUTTON_BORDER : LIGHT_BUTTON_BORDER,
  opacity: 0.6,
  minHeight: 'unset',
  height: 55,
  padding: '10px 20px',

  '&.Mui-disabled': {
    opacity: '0.25!important',
    '& svg path': {
      fill: theme.palette.type === 'dark' ? PLAIN_ICON : PRIMARY_ICON,
      opacity: 0.6,
    },
  },

  '& .MuiSvgIcon-root ': {
    margin: '4px 20px 0 0',
    height: 20,

    [theme.breakpoints.down('xs')]: {
      marginRight: 0,
      height: '30px',
      width: '30px',
    },
  },

  '& .MuiTab-wrapper': {
    flexDirection: 'unset',
    justifyContent: 'unset',
    alignItems: 'center',
  },

  '&.Mui-selected': {
    borderColor: PRIMARY_BUTTON_BORDER,
  },

  [theme.breakpoints.down('xs')]: {
    width: 100,
    minWidth: 'unset',
    height: 90,

    '& .MuiTab-wrapper': {
      flexDirection: 'column',
      justifyContent: 'center',
      lineHeight: 1.2,
      marginTop: -5,
      fontSize: 12,
    },
  },
}));

export const Content = styled('div')(({ theme }) => ({
  // MAIN CONTAINER
  width: '100%',
  height: '100%',
  borderRadius: 8,
  padding: 30,
  border: '1px solid',
  borderColor: theme.palette.type === 'dark' ? DARK_CARDS_CONTAINER : LIGHT_CONTAINER,
  background: theme.palette.type === 'dark' ? DARK_CARDS_CONTAINER : LIGHT_CONTAINER,
}));
